import * as t from "./actionTypes";
import {
	shapeService,
	// spotlightService
} from "client-app-core";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
// import center from "@turf/center";
// import { getSpotlight } from "orion-components/Map/helpers";

export const restoreShape = (id) =>
	shapeService.restore(id, (err, res) => {
		if (err) {
			console.log(err, res);
		}
	});

export const deleteShape = (id, name, undoing) => {
	return (dispatch) => {
		shapeService.delete(id, (err, response) => {
			if (err) {
				console.log(err, response);
			} else {
				if (!undoing) {
					const undoFunc = () => {
						dispatch(restoreShape(id));
					};
					dispatch(createUserFeedback(name + " has been deleted.", undoFunc));
				}
			}
		});
	};
};

export const createShape = (data) => {
	return (dispatch) => {
		const { properties, geometry, displayType, displayTargetId } = data;
		const {
			name,
			description,
			symbol,
			polyFill,
			polyStroke,
			polyFillOpacity,
			lineWidth,
			lineType,
			symbolCategory,
			lineStrokeOpacity,
			isRectangle = false,
			constrainProportion,
			isCircle,
			otherFeatures
		} = properties;

		const { type } = geometry;

		if (type !== "LineString" && type !== "Point") {
			geometry.type = "Polygon";
		}

		const shape = {
			entityData: {
				type: geometry.type,
				properties: {
					name,
					symbol,
					description,
					...(type === "Point" && { symbolCategory }),
					type: type === "LineString" ? "Line" : geometry.type,
					...(polyFill && { polyFill }),
					...(polyStroke && { polyStroke }),
					...(polyFillOpacity && { polyFillOpacity }),
					...(lineWidth && { lineWidth }),
					...(lineType && { lineType }),
					...(lineStrokeOpacity && { lineStrokeOpacity }),
					...(isRectangle && { isRectangle, constrainProportion }),
					...(isCircle && { isCircle, otherFeatures })
				},
				geometry
			}
		};

		shape.entityData.geometry.coordinates = normalizeCoordinates(shape);

		if (displayType && displayTargetId) {
			shape.entityData.displayType = displayType;
			shape.entityData.displayTargetId = displayTargetId;
		}

		shapeService.create(shape, (err, response) => {
			if (err) {
				console.log(err);
			} else {
				const id = response?.id;
				const undo = true;
				const undoFunc = () => {
					dispatch(deleteShape(id, name, undo));
				};
				dispatch(createUserFeedback(name + " has been created.", undoFunc));
			}
		});
	};
};

export const updateShape = (id, entityData, inScope) => {
	return () => {
		if (
			entityData?.geometry?.type == "Circle" ||
			entityData?.properties?.isCircle ||
			entityData?.geometry?.type == "Rectangle" ||
			entityData?.properties?.isRectangle
		) {
			entityData.geometry.type = "Polygon";
			entityData.type = "Polygon";
			entityData.properties.type = "Polygon";
		}
		const shape = { entityData };
		if (inScope !== undefined) {
			shape.inScope = inScope;
		}

		shape.entityData.geometry.coordinates = normalizeCoordinates(shape);

		shapeService.update(id, shape, (err, response) => {
			if (err) {
				console.log(err, response);
			}
		});
	};
};

export const updateCurrentFeature = (feature) => {
	return {
		type: t.UPDATE_CURRENT_FEATURE,
		payload: { feature }
	};
};

export const setMapTools = ({ type, mode, feature, latLng = [] }) => {
	return {
		type: t.SET_MAP_TOOLS,
		payload: { type, mode, feature, latLng }
	};
};

export const updatePath = (path) => {
	return { type: t.PATH_UPDATE, payload: { path } };
};

export const updatePaths = (paths) => {
	return { type: t.PATHS_UPDATE, payload: { paths } };
};

export const deletePath = (id) => {
	return { type: t.PATH_DELETE, payload: { id } };
};

export const setActivePath = (path) => {
	return { type: t.ACTIVE_PATH_SET, payload: { path } };
};

// export const removeSpotlight = (id) => {
// 	return {
// 		type: t.SPOTLIGHT_REMOVE,
// 		payload: { id }
// 	};
// };

// export const setSpotlight = (spotlight) => {
// 	return {
// 		type: t.SPOTLIGHT_SET,
// 		payload: { spotlight }
// 	};
// };

// export const restartSpotlight = (spotlight) => {
// 	return {
// 		type: t.SPOTLIGHT_RESTART,
// 		payload: { spotlight }
// 	};
// };

// export const addSpotlight = (feature) => {
// 	return (dispatch, getState) => {
// 		const { mapRef } = getState().mapState.baseMap;
// 		if (feature.geometry.type !== "Polygon") {
// 			feature.geometry = getSpotlight({
// 				center: center(feature.geometry),
// 				spotlightProximity: feature.spotlightProximity
// 			}).geometry;
// 		} else {
// 			feature.type = "Feature";
// 		}
// 		spotlightService.create(feature, (err, res) => {
// 			if (err) {
// 				console.log("Error creating spotlight", err);
// 			} else {
// 				const spotlight = res.spotlight;
// 				dispatch(setSpotlight(spotlight));
// 				mapRef.flyTo({
// 					center: center(spotlight.geometry).geometry.coordinates
// 				});
// 			}
// 		});
// 	};
// };

const normalizeCoordinates = (shape) => {
	// Function to normalize longitude values to the range -180 to 180
	function normalizeLongitude(x) {
		if (x < -180) {
			x += 360;
		} else if (x > 180) {
			x -= 360;
		}
		return x;
	}
	const currentCoordinates = shape.entityData.geometry.coordinates;

	// Update the longitude values within the range of -180 to 180
	let normalizedCoordinates;
	if (shape.entityData.type === "Polygon" || shape.entityData.geometry.type === "Polygon") {
		normalizedCoordinates = currentCoordinates.map((polygon) => {
			return polygon.map((point) => {
				let [x, y] = point;
				x = normalizeLongitude(x);
				return [x, y];
			});
		});
	} else if (shape.entityData.type === "LineString" || shape.entityData.geometry.type === "LineString") {
		normalizedCoordinates = currentCoordinates.map((point) => {
			let [x, y] = point;
			x = normalizeLongitude(x);
			return [x, y];
		});
	} else if (shape.entityData.type === "Point" || shape.entityData.geometry.type === "Point") {
		let [x, y] = currentCoordinates;
		x = normalizeLongitude(x);
		normalizedCoordinates = [x, y];
	} else {
		normalizedCoordinates = currentCoordinates;
	}

	return normalizedCoordinates;
};
